<template src="./dettaglioAgente.html"></template>


<script>
import TabellaFatturato from "@/components/statistiche/TabellaFatturato.vue";
import DettaglioCliente from "@/components/dialog/statistiche/DettaglioCliente.vue";

import { get_tabella } from "@/api/api.statistiche.js";

export default {
  props: {
    dialog: { type: Boolean, default: false },
    item: { type: Object, default: null },
    filtroTipologia: { type: String, default: "" },
    tipoFiltroSel: { type: Number, default: 0 },
    annoSel: { type: Number, default: 0 },
    userSwitch: { type: Object, default: null },
    role: { type: String, default: "" },
    dataDa: { type: String, default: "" },
    dataA: { type: String, default: "" },
    dataDa2: { type: String, default: "" },
    dataA2: { type: String, default: "" },
  },

  components: {
    TabellaFatturato,
    DettaglioCliente,
  },

  data: () => ({
    dati: [],
    headersTabella: [
      { text: "Nome", value: "AnNomAge", sortable: true, fatturato: "Nome" },
      /* { text: "Agente", value: "Agente" }, */
      { text: "Ragione. Sociale", value: "ClRagSoc", sortable: true },
      /* { text: "Cod Cli", value: "Cod_cli" }, */
      /* { text: "Provincia", value: "ClProvin" }, */
      { text: "Qta Periodo 1", value: "QuantitaPeriodo1", sortable: true },
      { text: "Qta Periodo 2", value: "QuantitaPeriodo2", sortable: true },
      { text: "Incremento", value: "PercIncremento", sortable: true },
    ],
    pagination: {
      sortBy: "ClRagSoc",
      rowsPerPage: 40,
    },
    datiTabella: [],
    rigaSelezionata: null,
    dialogRole: "Cliente",
    dialogUser: null,
    dialogCliente: false,

    page: 1,
    pageCount: 0,
    itemsPerPage: 40,

    sortBy: 'ClRagSoc',
    sortDesc: false,
  }),

  methods: {
    async caricaDati() {
      this.datiTabella = [];
      if (
        this.item == null ||
        this.item == undefined ||
        this.item == {} ||
        this.userSwitch == null
      ) {
        this.chiudiDialog();
        return;
      }

      let par = "";
      let date = {
        dataDa1: this.dataDa,
        dataA1: this.dataA,
        dataDa2: this.dataDa2,
        dataA2: this.dataA2,
      };
      if (this.userSwitch.Codice) {
        par += "/" + this.userSwitch.Tipo + "/" + this.userSwitch.Codice;

        if (this.tipoFiltroSel == 0) par += "/1";
        // confermati
        else if (this.tipoFiltroSel == 1) par += "/3";
        // consegnati
        else par += "/0"; //da confermare

        par += "/Tutti";
      } else return;
      let res = await get_tabella(par, date);
      this.datiTabella = res.data.DatiTabella;
      let totP1 = 0,
        totP2 = 0,
        totF1 = 0,
        totF2 = 0;

      this.datiTabella.forEach((el) => {
        totP1 += el.QuantitaPeriodo1;
        totP2 += el.QuantitaPeriodo2;
        totF1 += el.FatturatoPeriodo1;
        totF2 += el.FatturatoPeriodo2;
      });

      if (totP1 != undefined && totP2 != undefined && totP1 != 0) {
        this.headersTabella[2].text = "Qta Periodo 1 (" + totP1 + ")";
        this.headersTabella[2].fatturato = "Periodo 1 (" + totF1 + " €)";
        this.headersTabella[3].text = "Qta Periodo 1 (" + totP2 + ")";
        this.headersTabella[3].fatturato = "Periodo 1 (" + totF2 + " €)";
        this.headersTabella[4].text =
          "Incremento (" + (((totP2 - totP1) / totP1) * 100).toFixed(2) + "%)";
        this.headersTabella[4].fatturato =
          "Incremento (" + (((totF2 - totF1) / totF1) * 100).toFixed(2) + "%)";
      }
    },

    chiudiDialog() {
      this.$emit("chiudiDialog", true);
    },

    /* changeSort(item) {
      // Controllo sort attivo
      if (!item.sortable) return;
      if (this.pagination.sortBy === item.value) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = item.value;
        this.pagination.descending = false;
      }
    }, */

    changeSort(column) {
      // Se la colonna cliccata è già quella di ordinamento, cambia la direzione
      if (this.sortBy === column) {
        this.sortDesc = !this.sortDesc;
      } else {
        // Altrimenti, imposta la colonna di ordinamento e la direzione ascendente
        this.sortBy = column;
        this.sortDesc = false;
      }
    },

    apriDialogCliente(row) {
      this.dialogUser = { Tipo: "Cliente", Codice: row.Cod_cli };
      this.rigaSelezionata = row;
      this.dialogCliente = true;
    },

    chiudiDialogCliente() {
      this.rigaSelezionata = null;
      this.dialogCliente = false;
    },
  },
  mounted() {
    this.caricaDati();
  },

  watch: {
    dialog(val) {
      if (!val) return;
      this.caricaDati();
    },
  },
};
</script>